import { Tabs } from "expo-router";
import { StyleSheet } from "react-native";

export default function TabsLayout() {
  return (
    <Tabs
      screenOptions={{
        headerShown: false,
        tabBarButton: () => null,
        tabBarItemStyle: { display: "none" },
        tabBarStyle: { display: "none" },
        sceneStyle: styles.scene,
      }}
    >
      <Tabs.Screen name="directory" options={{ title: "Directory" }} />
      <Tabs.Screen name="profile" options={{ title: "Profile" }} />
    </Tabs>
  );
}

const styles = StyleSheet.create({
  scene: {
    flex: 1,
    minHeight: 0,
    backgroundColor: "#f8fafc",
  },
});
